import _ from "lodash";
import i18n from "i18next";
import { formatDate } from "../helpers/dateHelpers";

export const formatShipmentStatus = (shipmentStatus, dateDisplayFormat) => {
  return shipmentStatus && `${shipmentStatus.statusValue} - ${formatDate(shipmentStatus.date, dateDisplayFormat)}`;
};

export const getStatus = loadStatus => {
  const status = {
    label: i18n.t("loads.status.ToBeScheduled"),
    className: "--grey"
  };

  if (!_.isEmpty(loadStatus)) {
    const colors = { OnTime: "--green", Delayed: "--red", Delivered: "--blue", ToBeScheduled: "--grey" };
    status.label = loadStatus.statusValue;
    status.className = colors[loadStatus.statusCode] || "--grey";
  }

  return status;
};



// WEBPACK FOOTER //
// ./src/helpers/shipmentStatusHelpers.js